import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    // Disable browser's native scroll restoration
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    // Use rAF to wait until after paint — fixes mobile Safari timing
    const raf = requestAnimationFrame(() => {
      window.scrollTo(0, 0);
      document.body.scrollTop = 0; // iOS Safari
      document.documentElement.scrollTop = 0; // Chromium / Firefox
    });

    return () => cancelAnimationFrame(raf);
  }, [location.pathname, location.search, location.state]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

export default ScrollToTop;
